import * as React from 'react'

import { APPS } from 'modules/billing/lib/types'

import TimeTrackingButton, { Empty } from './TimeTrackingButton'

export const getActionWrapper = (id?: string): React.ElementType => {
  switch (id) {
    case APPS.time_tracking:
      return TimeTrackingButton

    default:
      return Empty
  }
}
